var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import reactDom from 'react-dom';
import { ToastComponent } from './ToastComponent';
var Toast = /** @class */ (function () {
    function Toast() {
    }
    Toast.prototype.createNotification = function () {
        return __awaiter(this, void 0, void 0, function () {
            var div, notification;
            return __generator(this, function (_a) {
                div = document.createElement('div');
                document.body.appendChild(div);
                reactDom.render(React.createElement(ToastComponent, { ref: function (container) { return (notification = container); } }), div);
                return [2 /*return*/, {
                        addNotice: function (notice) {
                            return notification.addNotice(notice);
                        },
                        destroy: function () {
                            reactDom.unmountComponentAtNode(div);
                            document.body.removeChild(div);
                        },
                    }];
            });
        });
    };
    Toast.prototype.notice = function (type, content, duration, onClose) {
        if (duration === void 0) { duration = 2; }
        return __awaiter(this, void 0, void 0, function () {
            var notification;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!notification) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.createNotification()];
                    case 1:
                        notification = _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, notification.addNotice({ type: type, content: content, duration: duration, onClose: onClose })];
                }
            });
        });
    };
    Toast.prototype.info = function (content, duration, onClose) {
        this.notice('info', content, duration, onClose);
    };
    Toast.prototype.success = function (content, duration, onClose) {
        if (content === void 0) { content = '操作成功'; }
        this.notice('success', content, duration, onClose);
    };
    Toast.prototype.fail = function (content, duration, onClose) {
        this.notice('fail', content, duration, onClose);
    };
    return Toast;
}());
var toast = new Toast();
export { toast };
//# sourceMappingURL=Toast.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/Toast/Toast.js
// module id = 298
// module chunks = 0